export default "__VITE_ASSET__Aw7SJWg1__"